module.exports = __webpack_public_path__ + "static/img/40006 (2).c2ab951.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40006 (2).webp
// module id = m/Dr
// module chunks = 14